<ng-container *ngrxLet="loadingLightTable$; let loading">
  @if (lightTableData && lightTableData.length > 0 && !loading) {
    <div #lightTable class="light-table-container" data-cy="light-table">
      @for (keyframeData of lightTableData; track keyframeData) {
        <div
          class="image-container"
                    [ngClass]="{
                        'active-keyframe-scroll': keyframeData.id === activeKeyframeId,
                        'no-access': !keyframeData.visible,
                        'image-container43' : mediaAspectRatio === '4:3',
                        'image-container169' : mediaAspectRatio === '16:9'
                    }"
          (click)="navigateTo(keyframeData.vtcInDuration)"
          >
          @if (keyframeData.id === activeKeyframeId) {
            <div class="active-keyframe-border"></div>
          }
          @if (selectionKeyframes[0] === keyframeData.id && markVtcIn) {
            <div class="in-out-label in-label">
              IN
            </div>
          }
          @if (hoveredKeyframes.indexOf(keyframeData.id) > -1) {
            <div class="hovered-keyframe"></div>
          }
          <img draggable="false"
            [src]="keyframeData.visible ? keyframeData.keyFrame : 'assets/images/no-access-keyframe.png'"
            alt=""
            [ngClass]="{ 'contains-in-out': selectionKeyframes.indexOf(keyframeData.id) > -1 }"
            />
            @if (selectionKeyframes[selectionKeyframes.length - 1] === keyframeData.id && markVtcOut) {
              <div
                class="in-out-label out-label"
                >
                OUT
              </div>
            }
          </div>
        }
      </div>
    }
    @if (loading) {
      <div class="loading-container">
        <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
      </div>
    }
  </ng-container>
